
/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

Mindbreeze.define('utils/events',["underscore", "backbone"], function(_, Backbone) {

//Regular expression used to split event strings.
  var eventSplitter = /\s+/;

  var splitEvents = function(name) {
    return name.split(eventSplitter);
  };

  return {


    proxyEvent: function(name, source) {
      var that = this;
      var names, lookupNames = null;
      if (_.isObject(name)) {
        names = _.keys(name);
        lookupNames = name;
      }
      else {
        names = splitEvents(name);
      }
      _.each(names, function(eventName) {
        // **all** is a special event, we have to deal with that separately
        if (eventName == "all") throw new Error("Forwarding all events is not supported.");
        var targetEventName = (lookupNames && lookupNames[eventName]) || eventName;

        // keep track of the callback functions for removing later based on
        // callback.
        if (!that._forwardCallbacks) that._forwardCallbacks = {};
        if (!that._forwardCallbacks[targetEventName]) {
          that._forwardCallbacks[targetEventName] = function() {
              var args = Array.prototype.slice.apply(arguments);
              args.unshift(targetEventName); // trigger requires to add the name of the event.
              // trace("triggering ", JSON.stringify(args));
              that.trigger.apply(that, args);
          };
        }
        source.on(eventName,  that._forwardCallbacks[targetEventName], that);
      });
    },

    stopProxyingEvent: function(name, source) {
      var that = this;
      var names, lookupNames = null;
      if (_.isObject(name)) {
        names = _.keys(name);
        lookupNames = name;
      }
      else {
        names = splitEvents(name);
      }
      _.each(names, function(eventName) {
        var targetEventName = (lookupNames && lookupNames[eventName]) || eventName;

        var callback;
        if (that._forwardCallbacks) callback = that._forwardCallbacks[targetEventName];
        source.off(eventName, callback, that);
      });
    },

    proxyAllEvents: function (source, blacklistRegex) {
      var that = this;
      this.listenTo(source, "all", function (eventName) {
        if (!blacklistRegex || !blacklistRegex.test(eventName)) {
          that.trigger.apply(that, arguments);
        }
      });
    }

  };

});
